// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.professional-availability-config {
  width: 100%;
}
.professional-availability-config :global(.page-layout__card) {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  border: none !important;
}
.professional-availability-config :global(.page-layout__header) {
  display: none !important;
}

.availability-workspace {
  display: grid;
  grid-template-columns: minmax(0, calc(66.666667% - 28px)) minmax(0, 1fr) !important;
  column-gap: 22px !important;
  align-items: start;
  width: 100%;
  max-width: none;
  margin: 0;
}
@media (max-width: 1380px) {
  .availability-workspace {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 20px !important;
  }
}

.availability-main-col {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  min-width: 0;
}

.profile-actions-sticky {
  position: sticky;
  top: 94px;
  z-index: 42;
  width: 100%;
  padding-top: 0;
  background: transparent;
}

.profile-actions {
  margin-bottom: 2px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 22px;
  background: #F7F5F1;
  box-shadow: 0 10px 26px rgba(18, 34, 29, 0.06);
  box-sizing: border-box;
}
.profile-actions .btn-edit {
  outline: none;
  border: 1px solid #82B194;
  background: #82B194;
  color: #fff;
  min-height: 40px;
  margin: 0 !important;
  padding: 0 18px;
  border-radius: 14px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.profile-actions .btn-edit:hover:not(:disabled) {
  background: rgb(114.2980295567, 167.2019704433, 134.5591133005);
}
.profile-actions .btn-edit:disabled, .profile-actions .btn-edit[aria-disabled=true] {
  opacity: 0.48;
  cursor: not-allowed;
  box-shadow: none;
}
.profile-actions .btn-edit:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.5);
}

.availability-settings {
  width: 100% !important;
  max-width: none !important;
  min-height: 620px !important;
  display: grid;
  align-content: start;
  gap: 8px;
  padding: 24px !important;
  background: var(--bw-card-surface, #F7F5F1);
  border: 1px solid rgba(16, 25, 21, 0.05);
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
}

.availability-overview {
  text-align: center;
}

.availability-settings-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin: 0 0 2px;
  color: #13231D;
  text-align: center;
}

.availability-settings-intro {
  font-size: 13px;
  color: var(--bw-muted, rgba(19, 35, 29, 0.68));
  line-height: 1.45;
  margin: 0 0 24px;
  text-align: center;
}

.availability-fieldset {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.availability-legend {
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  line-height: 1.35;
  text-transform: uppercase;
  color: #6E897C;
  margin: 0 0 8px;
  width: 100%;
  text-align: left;
}

.availability-options {
  display: grid;
  gap: 8px;
}

.availability-option {
  display: block;
  min-height: 0;
  padding: 0;
  border: 1px solid rgba(16, 25, 21, 0.09);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.34);
  transition: background-color 0.18s ease, border-color 0.18s ease;
  text-align: left;
  overflow: hidden;
}
.availability-option:hover {
  border-color: rgba(130, 177, 148, 0.48);
  background: rgba(130, 177, 148, 0.08);
}
.availability-option.is-selected {
  border-color: rgba(130, 177, 148, 0.68);
  background: rgba(130, 177, 148, 0.11);
}
.availability-option.is-readonly .availability-option-main {
  cursor: default;
}

.availability-option-main {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 11px 12px;
  cursor: pointer;
}
.availability-option-main input[type=radio] {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

.availability-option.is-selected .availability-option-main {
  padding-bottom: 10px;
}

.availability-radio {
  width: 20px;
  height: 20px;
  border: 1.5px solid rgba(19, 35, 29, 0.3);
  border-radius: 50%;
  display: grid;
  place-items: center;
  transition: all 0.2s ease;
  background: #F7F5F1;
  margin-top: 1px;
}
.availability-radio::after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #82B194;
  transform: scale(0);
  transition: transform 0.16s ease;
}

.availability-option.is-selected .availability-radio {
  border-color: #82B194;
}
.availability-option.is-selected .availability-radio::after {
  transform: scale(1);
}

.availability-option-copy {
  display: grid;
  gap: 5px;
  min-width: 0;
}
.availability-option-copy strong {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: #13231D;
}
.availability-option-copy span {
  font-size: 12px;
  color: var(--bw-muted, rgba(19, 35, 29, 0.68));
  line-height: 1.36;
}

.availability-option-detail {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  align-items: start;
  margin: 0 12px 12px 44px;
  padding: 10px 0 0;
  border-top: 1px solid rgba(19, 35, 29, 0.08);
  background: transparent;
}
@media (max-width: 520px) {
  .availability-option-detail {
    margin-left: 44px;
  }
}

.direct-availability {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  align-items: center;
}

.direct-availability-copy {
  display: grid;
  gap: 3px;
}
.direct-availability-copy span {
  font-size: 10.5px;
  line-height: 1.45;
  color: rgba(19, 35, 29, 0.58);
}

.request-availability {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px 10px;
  align-items: center;
}

.request-availability-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}
.request-availability-copy strong {
  font-size: 12px;
  line-height: 1.3;
  color: #13231D;
}
.request-availability-copy span {
  color: var(--bw-muted, rgba(19, 35, 29, 0.68));
  font-size: 10px;
  line-height: 1.4;
}

.request-availability-note {
  grid-column: 1/-1;
  font-size: 10px;
  color: #5E806C;
  line-height: 1.4;
  margin: 0;
}

.direct-configure,
.request-configure {
  justify-self: end;
  margin-top: 2px;
  min-height: 36px;
  padding: 0 13px;
  border: 1px solid rgba(130, 177, 148, 0.58);
  border-radius: 12px;
  background: transparent;
  color: #32453B !important;
  font: inherit;
  font-size: 10.5px;
  font-weight: 800;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.08s ease, background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.direct-configure:hover,
.request-configure:hover {
  background: rgba(130, 177, 148, 0.11) !important;
  border-color: rgba(130, 177, 148, 0.72) !important;
}
.direct-configure:active,
.request-configure:active {
  transform: translateY(1px);
  background: rgba(130, 177, 148, 0.18) !important;
  border-color: #82B194 !important;
}
.direct-configure:focus-visible,
.request-configure:focus-visible {
  outline: 2px solid rgba(130, 177, 148, 0.36);
  outline-offset: 2px;
}
.direct-configure:disabled, .direct-configure[disabled],
.request-configure:disabled,
.request-configure[disabled] {
  opacity: 0.38;
  cursor: not-allowed !important;
  pointer-events: none;
  border-color: rgba(19, 35, 29, 0.16) !important;
  background: transparent !important;
  color: rgba(19, 35, 29, 0.4) !important;
  transform: none !important;
  box-shadow: none !important;
}

.availability-divider {
  height: 1px;
  background: rgba(16, 25, 21, 0.07);
  margin: 18px 0;
}

.chat-highlight {
  padding: 15px 16px;
  border: 1px solid rgba(130, 177, 148, 0.24);
  border-radius: 16px;
  background: rgba(130, 177, 148, 0.055);
  display: grid;
  gap: 9px;
  text-align: left;
}

.chat-setting {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
}

.chat-setting-main {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 11px;
  align-items: start;
  min-width: 0;
}

.chat-icon {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  background: rgba(130, 177, 148, 0.14);
  color: #557865;
}
.chat-icon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linejoin: round;
}

.chat-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.chat-title-row strong {
  font-size: 13px;
  line-height: 1.3;
  color: #13231D;
  font-weight: 700;
}

.chat-tag {
  display: inline-flex !important;
  align-items: center;
  min-height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.13);
  border: 1px solid rgba(130, 177, 148, 0.24);
  color: #557865 !important;
  font-size: 8.5px !important;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.chat-setting-copy {
  display: grid;
  gap: 3px;
}
.chat-setting-copy span {
  font-size: 12px;
  color: var(--bw-muted, rgba(19, 35, 29, 0.68));
  line-height: 1.4;
}

.chat-benefit {
  padding-left: 47px;
  color: rgba(19, 35, 29, 0.62);
  font-size: 10.5px;
  line-height: 1.5;
  margin: 0;
}
.chat-benefit strong {
  color: #557865;
  font-weight: 800;
}
@media (max-width: 620px) {
  .chat-benefit {
    padding-left: 0;
  }
}

.switch {
  position: relative;
  display: inline-flex;
  width: 48px;
  height: 28px;
  flex: 0 0 48px;
  cursor: pointer;
}
.switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.switch .switch-track {
  width: 100%;
  height: 100%;
  padding: 3px;
  border-radius: 999px;
  background: rgba(19, 35, 29, 0.16);
  border: 1px solid rgba(19, 35, 29, 0.08);
  transition: background-color 0.18s ease, border-color 0.18s ease;
}
.switch .switch-track .switch-thumb {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(18, 34, 28, 0.16);
  transition: transform 0.18s ease;
}
.switch input:checked + .switch-track {
  background: #82B194;
  border-color: #82B194;
}
.switch input:checked + .switch-track .switch-thumb {
  transform: translateX(20px);
}
.switch:hover .switch-track {
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.09);
}
.switch.is-disabled {
  cursor: default;
  pointer-events: none;
}
.switch.is-disabled .switch-track {
  opacity: 0.55;
}
.switch.is-disabled:hover .switch-track {
  box-shadow: none;
}

.availability-guide {
  position: sticky !important;
  top: 94px !important;
  align-self: start !important;
  max-height: calc(100dvh - 122px) !important;
  overflow-y: auto !important;
  scrollbar-width: thin;
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
}
@media (max-width: 1380px) {
  .availability-guide {
    position: static !important;
  }
}

.availability-guide-card {
  padding: 24px;
  border: 1px solid rgba(16, 25, 21, 0.06);
  border-radius: 24px;
  background: #F7F5F1;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}

.availability-guide-kicker {
  display: block;
  margin-bottom: 8px;
  color: #6E897C;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.availability-guide-title {
  margin: 0 0 8px;
  font-size: 19px;
  line-height: 1.2;
  letter-spacing: -0.025em;
  color: #13231D;
  font-weight: 800;
}

.availability-guide-lead {
  margin: 0;
  color: rgba(19, 35, 29, 0.68);
  font-size: 12.5px;
  line-height: 1.55;
}

.availability-guide-points {
  display: grid;
  gap: 12px;
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid rgba(19, 35, 29, 0.08);
}

.availability-guide-point {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}
.availability-guide-point > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: rgba(130, 177, 148, 0.13);
  color: #557865;
  font-size: 11px;
  font-weight: 800;
}
.availability-guide-point strong {
  display: block;
  margin: 1px 0 2px;
  font-size: 12px;
  line-height: 1.3;
  color: #13231D;
  font-weight: 800;
}
.availability-guide-point p {
  margin: 0;
  color: rgba(19, 35, 29, 0.6);
  font-size: 10.8px;
  line-height: 1.5;
}

.availability-guide-note {
  display: grid;
  gap: 3px;
  margin-top: 18px;
  padding: 14px;
  border: 1px solid rgba(130, 177, 148, 0.22);
  border-radius: 14px;
  background: rgba(130, 177, 148, 0.07);
}
.availability-guide-note strong {
  font-size: 11.5px;
  color: #32453B;
  font-weight: 800;
}
.availability-guide-note span {
  color: rgba(19, 35, 29, 0.62);
  font-size: 10.6px;
  line-height: 1.45;
}

/* Guardado inferior: un solo patrón */
.availability-shared-save {
  position: sticky !important;
  bottom: 20px !important;
  top: auto !important;
  z-index: 40 !important;
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 1000px !important;
  margin: 14px 0 0 !important;
}
.availability-shared-save .save-pill {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 1000px !important;
  min-height: 74px !important;
  height: auto !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 14px !important;
  padding: 12px 12px 12px 24px !important;
  border-radius: 28px !important;
  background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%) !important;
  border: 1px solid rgba(16, 25, 21, 0.08) !important;
  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.1) !important;
}
.availability-shared-save .save-state {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 12px !important;
}
.availability-shared-save .save-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #D6A640;
  flex: 0 0 10px;
  margin-top: 5px;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}
.availability-shared-save .save-dot.is-saved {
  background: rgba(19, 35, 29, 0.18) !important;
}
.availability-shared-save .save-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.availability-shared-save .save-actions {
  flex: 0 0 auto !important;
  display: grid !important;
  grid-template-columns: 104px 148px !important;
  align-items: stretch !important;
  gap: 10px !important;
  flex-wrap: nowrap !important;
  width: auto !important;
}
.availability-shared-save .save-actions > button {
  width: 100% !important;
  min-width: 0 !important;
  height: 42px !important;
  min-height: 42px !important;
  padding: 0 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 14px !important;
  white-space: nowrap !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s ease;
}
.availability-shared-save .save-actions .btn-save-exit {
  background: transparent !important;
  border: 1px solid rgba(130, 177, 148, 0.4) !important;
  color: #13231D !important;
}
.availability-shared-save .save-actions .btn-save-exit:hover {
  background: rgba(130, 177, 148, 0.1) !important;
  border-color: rgba(130, 177, 148, 0.48) !important;
}
.availability-shared-save .save-actions .btn-save-exit:active {
  transform: translateY(1px);
}
.availability-shared-save .save-actions .save-cta {
  background: #82B194 !important;
  border: 1px solid transparent !important;
  color: #fff !important;
  box-shadow: none !important;
}
.availability-shared-save .save-actions .save-cta:hover:not(:disabled) {
  background: #739F84 !important;
}
.availability-shared-save .save-actions .save-cta:active:not(:disabled) {
  transform: translateY(1px);
}
.availability-shared-save .save-actions .save-cta:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.availability-shared-save .save-actions .save-cta.is-saved {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: rgba(130, 177, 148, 0.42) !important;
  color: #294439 !important;
  cursor: default;
}
.availability-shared-save .save-copy {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: #13231D !important;
  line-height: 1.25 !important;
  margin-bottom: 2px !important;
}
.availability-shared-save .save-sub {
  font-size: 12px !important;
  line-height: 1.35 !important;
  color: #6C7771 !important;
}
@media (max-width: 620px) {
  .availability-shared-save .save-pill {
    flex-direction: column !important;
    align-items: stretch !important;
    padding: 14px !important;
  }
  .availability-shared-save .save-actions {
    width: 100% !important;
    grid-template-columns: 1fr 1fr !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AvailabilityConfigurationPage/AvailabilityConfigurationPage.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;AAEF;AAAE;EACE,kCAAA;EACA,2BAAA;EACA,qBAAA;EACA,uBAAA;AAEJ;AACE;EACE,wBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mFAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AAAF;AAEE;EATF;IAUI,gDAAA;IACA,oBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AACJ;AACI;EACE,+DAAA;AACN;AAEI;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;AADN;AAII;EACE,aAAA;EACA,8CAAA;AAFN;;AAOA;EACE,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;EACA,QAAA;EACA,wBAAA;EACA,2CAAA;EACA,wCAAA;EACA,mBAAA;EACA,2CAAA;EACA,sBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAJF;;AAOA;EACE,eAAA;EACA,8CAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,SAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,QAAA;AAJF;;AAOA;EACE,cAAA;EACA,aAAA;EACA,UAAA;EACA,wCAAA;EACA,mBAAA;EACA,qCAAA;EACA,gEAAA;EACA,gBAAA;EACA,gBAAA;AAJF;AAME;EACE,uCAAA;EACA,qCAAA;AAJJ;AAOE;EACE,uCAAA;EACA,qCAAA;AALJ;AASI;EACE,eAAA;AAPN;;AAYA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AATF;AAWE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AATJ;;AAaA;EACE,oBAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAVF;AAYE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAVJ;;AAcA;EACE,qBAAA;AAXF;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAZJ;AAeE;EACE,eAAA;EACA,8CAAA;EACA,iBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,0BAAA;EACA,QAAA;EACA,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,4CAAA;EACA,uBAAA;AAdF;AAgBE;EAVF;IAWI,iBAAA;EAbF;AACF;;AAgBA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,QAAA;AAbF;AAeE;EACE,iBAAA;EACA,iBAAA;EACA,6BAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAdF;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAdJ;AAiBE;EACE,8CAAA;EACA,eAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAhBF;;AAmBA;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,uGAAA;AAhBF;AAkBE;;EACE,gDAAA;EACA,kDAAA;AAfJ;AAkBE;;EACE,0BAAA;EACA,gDAAA;EACA,gCAAA;AAfJ;AAkBE;;EACE,4CAAA;EACA,mBAAA;AAfJ;AAkBE;;;EAEE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,+CAAA;EACA,kCAAA;EACA,uCAAA;EACA,0BAAA;EACA,2BAAA;AAfJ;;AAmBA;EACE,WAAA;EACA,kCAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;AAhBF;AAkBE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAjBF;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAjBJ;;AAqBA;EACE,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,qCAAA;EACA,2CAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,QAAA;AAlBF;AAoBE;EACE,eAAA;EACA,8CAAA;EACA,gBAAA;AAlBJ;;AAsBA;EACE,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AAnBF;AAqBE;EACE,cAAA;EACA,gBAAA;AAnBJ;AAsBE;EAZF;IAaI,eAAA;EAnBF;AACF;;AAsBA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAnBF;AAqBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAnBJ;AAsBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,kCAAA;EACA,wCAAA;EACA,gEAAA;AApBJ;AAsBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,gCAAA;AApBN;AAwBE;EACE,mBAAA;EACA,qBAAA;AAtBJ;AAwBI;EACE,2BAAA;AAtBN;AA0BE;EACE,+CAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,oBAAA;AAzBJ;AA2BI;EACE,aAAA;AAzBN;AA4BI;EACE,gBAAA;AA1BN;;AA+BA;EACE,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,2CAAA;EACA,2BAAA;EACA,qBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;AA5BF;AA8BE;EAXF;IAYI,2BAAA;EA3BF;AACF;;AA8BA;EACE,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,4CAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;AA3BF;AA6BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,SAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,qCAAA;AA9BF;AAgCE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,6BAAA;EACA,iBAAA;EACA,iBAAA;AA/BJ;;AAmCA,sCAAA;AACA;EACE,2BAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iCAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAhCF;AAkCE;EACE,iCAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,oBAAA;EACA,uCAAA;EACA,8BAAA;EACA,iGAAA;EACA,mDAAA;EACA,wDAAA;AAhCJ;AAmCE;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oBAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AAlCJ;AAoCI;EACE,6CAAA;AAlCN;AAsCE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AApCJ;AAuCE;EACE,yBAAA;EACA,wBAAA;EACA,6CAAA;EACA,+BAAA;EACA,oBAAA;EACA,4BAAA;EACA,sBAAA;AArCJ;AAuCI;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;AArCN;AAwCI;EACE,kCAAA;EACA,qDAAA;EACA,yBAAA;AAtCN;AAwCM;EACE,+CAAA;EACA,kDAAA;AAtCR;AAyCM;EACE,0BAAA;AAvCR;AA2CI;EACE,8BAAA;EACA,wCAAA;EACA,sBAAA;EACA,2BAAA;AAzCN;AA2CM;EACE,8BAAA;AAzCR;AA4CM;EACE,0BAAA;AA1CR;AA6CM;EACE,YAAA;EACA,mBAAA;AA3CR;AA8CM;EACE,gDAAA;EACA,kDAAA;EACA,yBAAA;EACA,eAAA;AA5CR;AAiDE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;AA/CJ;AAkDE;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AAhDJ;AAmDE;EACE;IACE,iCAAA;IACA,+BAAA;IACA,wBAAA;EAjDJ;EAoDE;IACE,sBAAA;IACA,yCAAA;EAlDJ;AACF","sourcesContent":[".professional-availability-config {\n  width: 100%;\n\n  :global(.page-layout__card) {\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    border: none !important;\n  }\n\n  :global(.page-layout__header) {\n    display: none !important;\n  }\n}\n\n.availability-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, calc(66.666667% - 28px)) minmax(0, 1fr) !important;\n  column-gap: 22px !important;\n  align-items: start;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n\n  @media (max-width: 1380px) {\n    grid-template-columns: minmax(0, 1fr) !important;\n    gap: 20px !important;\n  }\n}\n\n.availability-main-col {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  width: 100%;\n  min-width: 0;\n}\n\n.profile-actions-sticky {\n  position: sticky;\n  top: 94px;\n  z-index: 42;\n  width: 100%;\n  padding-top: 0;\n  background: transparent;\n}\n\n.profile-actions {\n  margin-bottom: 2px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid rgba(19, 35, 29, 0.08);\n  border-radius: 22px;\n  background: #F7F5F1;\n  box-shadow: 0 10px 26px rgba(18, 34, 29, 0.06);\n  box-sizing: border-box;\n\n  .btn-edit {\n    outline: none;\n    border: 1px solid #82B194;\n    background: #82B194;\n    color: #fff;\n    min-height: 40px;\n    margin: 0 !important;\n    padding: 0 18px;\n    border-radius: 14px;\n    font-family: inherit;\n    font-size: 12px;\n    font-weight: 800;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover:not(:disabled) {\n      background: darken(#82B194, 5%);\n    }\n\n    &:disabled,\n    &[aria-disabled=\"true\"] {\n      opacity: 0.48;\n      cursor: not-allowed;\n      box-shadow: none;\n    }\n\n    &:focus-visible {\n      outline: none;\n      box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.5);\n    }\n  }\n}\n\n.availability-settings {\n  width: 100% !important;\n  max-width: none !important;\n  min-height: 620px !important;\n  display: grid;\n  align-content: start;\n  gap: 8px;\n  padding: 24px !important;\n  background: var(--bw-card-surface, #F7F5F1);\n  border: 1px solid rgba(16, 25, 21, 0.05);\n  border-radius: 24px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);\n  box-sizing: border-box;\n}\n\n.availability-overview {\n  text-align: center;\n}\n\n.availability-settings-title {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  margin: 0 0 2px;\n  color: #13231D;\n  text-align: center;\n}\n\n.availability-settings-intro {\n  font-size: 13px;\n  color: var(--bw-muted, rgba(19, 35, 29, 0.68));\n  line-height: 1.45;\n  margin: 0 0 24px;\n  text-align: center;\n}\n\n.availability-fieldset {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n}\n\n.availability-legend {\n  display: block;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  line-height: 1.35;\n  text-transform: uppercase;\n  color: #6E897C;\n  margin: 0 0 8px;\n  width: 100%;\n  text-align: left;\n}\n\n.availability-options {\n  display: grid;\n  gap: 8px;\n}\n\n.availability-option {\n  display: block;\n  min-height: 0;\n  padding: 0;\n  border: 1px solid rgba(16, 25, 21, 0.09);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.34);\n  transition: background-color 0.18s ease, border-color 0.18s ease;\n  text-align: left;\n  overflow: hidden;\n\n  &:hover {\n    border-color: rgba(130, 177, 148, 0.48);\n    background: rgba(130, 177, 148, 0.08);\n  }\n\n  &.is-selected {\n    border-color: rgba(130, 177, 148, 0.68);\n    background: rgba(130, 177, 148, 0.11);\n  }\n\n  &.is-readonly {\n    .availability-option-main {\n      cursor: default;\n    }\n  }\n}\n\n.availability-option-main {\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n  padding: 11px 12px;\n  cursor: pointer;\n\n  input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    width: 1px;\n    height: 1px;\n    pointer-events: none;\n  }\n}\n\n.availability-option.is-selected .availability-option-main {\n  padding-bottom: 10px;\n}\n\n.availability-radio {\n  width: 20px;\n  height: 20px;\n  border: 1.5px solid rgba(19, 35, 29, 0.30);\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  transition: all 0.2s ease;\n  background: #F7F5F1;\n  margin-top: 1px;\n\n  &::after {\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #82B194;\n    transform: scale(0);\n    transition: transform 0.16s ease;\n  }\n}\n\n.availability-option.is-selected .availability-radio {\n  border-color: #82B194;\n\n  &::after {\n    transform: scale(1);\n  }\n}\n\n.availability-option-copy {\n  display: grid;\n  gap: 5px;\n  min-width: 0;\n\n  strong {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.3;\n    color: #13231D;\n  }\n\n  span {\n    font-size: 12px;\n    color: var(--bw-muted, rgba(19, 35, 29, 0.68));\n    line-height: 1.36;\n  }\n}\n\n.availability-option-detail {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  align-items: start;\n  margin: 0 12px 12px 44px;\n  padding: 10px 0 0;\n  border-top: 1px solid rgba(19, 35, 29, 0.08);\n  background: transparent;\n\n  @media (max-width: 520px) {\n    margin-left: 44px;\n  }\n}\n\n.direct-availability {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 14px;\n  align-items: center;\n}\n\n.direct-availability-copy {\n  display: grid;\n  gap: 3px;\n\n  span {\n    font-size: 10.5px;\n    line-height: 1.45;\n    color: rgba(19, 35, 29, 0.58);\n  }\n}\n\n.request-availability {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 8px 10px;\n  align-items: center;\n}\n\n.request-availability-copy {\n  display: grid;\n  gap: 3px;\n  min-width: 0;\n\n  strong {\n    font-size: 12px;\n    line-height: 1.3;\n    color: #13231D;\n  }\n\n  span {\n    color: var(--bw-muted, rgba(19, 35, 29, 0.68));\n    font-size: 10px;\n    line-height: 1.4;\n  }\n}\n\n.request-availability-note {\n  grid-column: 1 / -1;\n  font-size: 10px;\n  color: #5E806C;\n  line-height: 1.4;\n  margin: 0;\n}\n\n.direct-configure,\n.request-configure {\n  justify-self: end;\n  margin-top: 2px;\n  min-height: 36px;\n  padding: 0 13px;\n  border: 1px solid rgba(130, 177, 148, 0.58);\n  border-radius: 12px;\n  background: transparent;\n  color: #32453B !important;\n  font: inherit;\n  font-size: 10.5px;\n  font-weight: 800;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: transform 0.08s ease, background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    background: rgba(130, 177, 148, 0.11) !important;\n    border-color: rgba(130, 177, 148, 0.72) !important;\n  }\n\n  &:active {\n    transform: translateY(1px);\n    background: rgba(130, 177, 148, 0.18) !important;\n    border-color: #82B194 !important;\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba(130, 177, 148, 0.36);\n    outline-offset: 2px;\n  }\n\n  &:disabled,\n  &[disabled] {\n    opacity: 0.38;\n    cursor: not-allowed !important;\n    pointer-events: none;\n    border-color: rgba(19, 35, 29, 0.16) !important;\n    background: transparent !important;\n    color: rgba(19, 35, 29, 0.40) !important;\n    transform: none !important;\n    box-shadow: none !important;\n  }\n}\n\n.availability-divider {\n  height: 1px;\n  background: rgba(16, 25, 21, 0.07);\n  margin: 18px 0;\n}\n\n.chat-highlight {\n  padding: 15px 16px;\n  border: 1px solid rgba(130, 177, 148, 0.24);\n  border-radius: 16px;\n  background: rgba(130, 177, 148, 0.055);\n  display: grid;\n  gap: 9px;\n  text-align: left;\n}\n\n.chat-setting {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 16px;\n  align-items: center;\n}\n\n.chat-setting-main {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr);\n  gap: 11px;\n  align-items: start;\n  min-width: 0;\n}\n\n.chat-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 11px;\n  display: grid;\n  place-items: center;\n  background: rgba(130, 177, 148, 0.14);\n  color: #557865;\n\n  svg {\n    width: 18px;\n    height: 18px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 1.7;\n    stroke-linejoin: round;\n  }\n}\n\n.chat-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n\n  strong {\n    font-size: 13px;\n    line-height: 1.3;\n    color: #13231D;\n    font-weight: 700;\n  }\n}\n\n.chat-tag {\n  display: inline-flex !important;\n  align-items: center;\n  min-height: 20px;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: rgba(130, 177, 148, 0.13);\n  border: 1px solid rgba(130, 177, 148, 0.24);\n  color: #557865 !important;\n  font-size: 8.5px !important;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.chat-setting-copy {\n  display: grid;\n  gap: 3px;\n\n  span {\n    font-size: 12px;\n    color: var(--bw-muted, rgba(19, 35, 29, 0.68));\n    line-height: 1.4;\n  }\n}\n\n.chat-benefit {\n  padding-left: 47px;\n  color: rgba(19, 35, 29, 0.62);\n  font-size: 10.5px;\n  line-height: 1.5;\n  margin: 0;\n\n  strong {\n    color: #557865;\n    font-weight: 800;\n  }\n\n  @media (max-width: 620px) {\n    padding-left: 0;\n  }\n}\n\n.switch {\n  position: relative;\n  display: inline-flex;\n  width: 48px;\n  height: 28px;\n  flex: 0 0 48px;\n  cursor: pointer;\n\n  input {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    opacity: 0;\n  }\n\n  .switch-track {\n    width: 100%;\n    height: 100%;\n    padding: 3px;\n    border-radius: 999px;\n    background: rgba(19, 35, 29, 0.16);\n    border: 1px solid rgba(19, 35, 29, 0.08);\n    transition: background-color 0.18s ease, border-color 0.18s ease;\n\n    .switch-thumb {\n      display: block;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      background: #fff;\n      box-shadow: 0 2px 6px rgba(18, 34, 28, 0.16);\n      transition: transform 0.18s ease;\n    }\n  }\n\n  input:checked + .switch-track {\n    background: #82B194;\n    border-color: #82B194;\n\n    .switch-thumb {\n      transform: translateX(20px);\n    }\n  }\n\n  &:hover .switch-track {\n    box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.09);\n  }\n\n  &.is-disabled {\n    cursor: default;\n    pointer-events: none;\n\n    .switch-track {\n      opacity: 0.55;\n    }\n\n    &:hover .switch-track {\n      box-shadow: none;\n    }\n  }\n}\n\n.availability-guide {\n  position: sticky !important;\n  top: 94px !important;\n  align-self: start !important;\n  max-height: calc(100dvh - 122px) !important;\n  overflow-y: auto !important;\n  scrollbar-width: thin;\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0 !important;\n\n  @media (max-width: 1380px) {\n    position: static !important;\n  }\n}\n\n.availability-guide-card {\n  padding: 24px;\n  border: 1px solid rgba(16, 25, 21, 0.06);\n  border-radius: 24px;\n  background: #F7F5F1;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);\n}\n\n.availability-guide-kicker {\n  display: block;\n  margin-bottom: 8px;\n  color: #6E897C;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.availability-guide-title {\n  margin: 0 0 8px;\n  font-size: 19px;\n  line-height: 1.2;\n  letter-spacing: -0.025em;\n  color: #13231D;\n  font-weight: 800;\n}\n\n.availability-guide-lead {\n  margin: 0;\n  color: rgba(19, 35, 29, 0.68);\n  font-size: 12.5px;\n  line-height: 1.55;\n}\n\n.availability-guide-points {\n  display: grid;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 18px;\n  border-top: 1px solid rgba(19, 35, 29, 0.08);\n}\n\n.availability-guide-point {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr);\n  gap: 10px;\n  align-items: start;\n\n  & > span {\n    width: 28px;\n    height: 28px;\n    display: grid;\n    place-items: center;\n    border-radius: 9px;\n    background: rgba(130, 177, 148, 0.13);\n    color: #557865;\n    font-size: 11px;\n    font-weight: 800;\n  }\n\n  strong {\n    display: block;\n    margin: 1px 0 2px;\n    font-size: 12px;\n    line-height: 1.3;\n    color: #13231D;\n    font-weight: 800;\n  }\n\n  p {\n    margin: 0;\n    color: rgba(19, 35, 29, 0.60);\n    font-size: 10.8px;\n    line-height: 1.5;\n  }\n}\n\n.availability-guide-note {\n  display: grid;\n  gap: 3px;\n  margin-top: 18px;\n  padding: 14px;\n  border: 1px solid rgba(130, 177, 148, 0.22);\n  border-radius: 14px;\n  background: rgba(130, 177, 148, 0.07);\n\n  strong {\n    font-size: 11.5px;\n    color: #32453B;\n    font-weight: 800;\n  }\n\n  span {\n    color: rgba(19, 35, 29, 0.62);\n    font-size: 10.6px;\n    line-height: 1.45;\n  }\n}\n\n/* Guardado inferior: un solo patrón */\n.availability-shared-save {\n  position: sticky !important;\n  bottom: 20px !important;\n  top: auto !important;\n  z-index: 40 !important;\n  box-sizing: border-box !important;\n  width: 100% !important;\n  max-width: 1000px !important;\n  margin: 14px 0 0 !important;\n\n  .save-pill {\n    box-sizing: border-box !important;\n    width: 100% !important;\n    max-width: 1000px !important;\n    min-height: 74px !important;\n    height: auto !important;\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: nowrap !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    gap: 14px !important;\n    padding: 12px 12px 12px 24px !important;\n    border-radius: 28px !important;\n    background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%) !important;\n    border: 1px solid rgba(16, 25, 21, 0.08) !important;\n    box-shadow: 0 10px 18px rgba(18, 34, 28, 0.10) !important;\n  }\n\n  .save-state {\n    flex: 1 1 auto !important;\n    min-width: 0 !important;\n    display: flex !important;\n    align-items: flex-start !important;\n    gap: 12px !important;\n  }\n\n  .save-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #D6A640;\n    flex: 0 0 10px;\n    margin-top: 5px;\n    transition: opacity 0.2s ease, background-color 0.2s ease;\n\n    &.is-saved {\n      background: rgba(19, 35, 29, 0.18) !important;\n    }\n  }\n\n  .save-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .save-actions {\n    flex: 0 0 auto !important;\n    display: grid !important;\n    grid-template-columns: 104px 148px !important;\n    align-items: stretch !important;\n    gap: 10px !important;\n    flex-wrap: nowrap !important;\n    width: auto !important;\n\n    > button {\n      width: 100% !important;\n      min-width: 0 !important;\n      height: 42px !important;\n      min-height: 42px !important;\n      padding: 0 10px !important;\n      display: inline-flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      border-radius: 14px !important;\n      white-space: nowrap !important;\n      font-size: 13px !important;\n      font-weight: 800 !important;\n      cursor: pointer;\n      font-family: inherit;\n      transition: all 0.2s ease;\n    }\n\n    .btn-save-exit {\n      background: transparent !important;\n      border: 1px solid rgba(130, 177, 148, 0.40) !important;\n      color: #13231D !important;\n\n      &:hover {\n        background: rgba(130, 177, 148, 0.10) !important;\n        border-color: rgba(130, 177, 148, 0.48) !important;\n      }\n\n      &:active {\n        transform: translateY(1px);\n      }\n    }\n\n    .save-cta {\n      background: #82B194 !important;\n      border: 1px solid transparent !important;\n      color: #fff !important;\n      box-shadow: none !important;\n\n      &:hover:not(:disabled) {\n        background: #739F84 !important;\n      }\n\n      &:active:not(:disabled) {\n        transform: translateY(1px);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n\n      &.is-saved {\n        background: rgba(130, 177, 148, 0.16) !important;\n        border-color: rgba(130, 177, 148, 0.42) !important;\n        color: #294439 !important;\n        cursor: default;\n      }\n    }\n  }\n\n  .save-copy {\n    font-size: 13px !important;\n    font-weight: 800 !important;\n    color: #13231D !important;\n    line-height: 1.25 !important;\n    margin-bottom: 2px !important;\n  }\n\n  .save-sub {\n    font-size: 12px !important;\n    line-height: 1.35 !important;\n    color: #6C7771 !important;\n  }\n\n  @media (max-width: 620px) {\n    .save-pill {\n      flex-direction: column !important;\n      align-items: stretch !important;\n      padding: 14px !important;\n    }\n\n    .save-actions {\n      width: 100% !important;\n      grid-template-columns: 1fr 1fr !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
